/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useState, useEffect } from 'react';
// redux
import { useSelector } from 'react-redux';
// material
import LoadingState from '../../../../material/states/loading/loading';
import NoDataState from '../../../../material/states/nodata/nodata';
import LinkControls from '../../../../material/cardwrapper/linkcontrols/linkcontrols';
import CardWrapper from '../../../../material/cardwrapper/cardwrapper';
import CardToggles from '../../../../material/cardwrapper/cardtoggles/cardtoggles';
import CardToggle from '../../../../material/cardwrapper/cardtoggles/cardtoggle/cardtoggle';
import RevenueReportChart from './revenuereportchart/revenuereportchart';
// utils
import { formatNumber, getChangeRateDirection, getEnabledRollUps } from '../../../../utils/charts';
// styles
import injectSheet from 'react-jss';
import styles from './revenuereportsection_styles';



/* ========== ~~~~~~~~~~ REVENUE REPORT SECTION ~~~~~~~~~~ ========== */
const RevenueReportSection = injectSheet(styles)((props) => {
    const toggles = [
        {id: 'TOTAL', label: 'Total Revenue'},
        {id: 'VIDEO', label: 'Video'},
        {id: 'DISPLAY', label: 'Display'}
    ];

	const [revenueToggle, changeRevenueToggle] = useState('Total Revenue');
	const [selected, changeSelected] = useState('daily');
    const [enabledRollups, setEnabledRollups] = useState([]);

    const { overview, details, compareTo, status } = useSelector((state) => {
        return state.revenueOverview.overviewChart
    });
    const { filters } = useSelector((state) => state.app);
    const [currentCompareTo, setCurrentCompareTo] = useState(filters.compareTo);

    const dataType = revenueToggle.split(" ")[0].toUpperCase(); // TOTAL, DISPLAY, VIDEO
    const period = `${selected[0].toUpperCase()}${selected.slice(1)}`; // Daily, Monthly, Weekly, Quarterly
    const currentTotalDetail =  Object.keys(details[dataType][period].TOTAL);

    useEffect(() => {
        if(status === 'fulfilled' && enabledRollups.length === 0) {
            const rollups = getEnabledRollUps(details[dataType]);
            setEnabledRollups(rollups);
            if(rollups.length > 0) changeSelected(rollups[0]);
        } else {
            setEnabledRollups([]);
            changeSelected('daily');
        }
    }, [status]);

    useEffect(() => {
        // only apply the compare to filter on graph on click of 'Apply' button
        if(status === 'fulfilled' && currentCompareTo != filters.compareTo) setCurrentCompareTo(filters.compareTo);
    }, [status]);

	const formatDataForRevenueReport = () => {
		const revenueReport = [{id: 'Current', data: {}}, {id: 'CompareTo', data: {}}];
		revenueReport[0].data = details[dataType][period].TOTAL;
		revenueReport[1].data = currentCompareTo === 'YoY' ? compareTo[dataType][period] : {}
		return revenueReport;
	}

    const isNoData = () => {
        return  (status === 'rejected') ||
                (status === 'fulfilled' && currentTotalDetail.length === 0) ||
                (status === 'fulfilled' && overview[dataType].revenue === 0);
    }
    const isShowData = () => status !== 'pending' && !isNoData();
    const isLoading = () => status === 'pending';

    const cardToggles = (
        <CardToggles>
            { toggles.filter(toggle => overview[toggle.id].revenue > 0).map(toggle =>
                toggle.id !== 'TOTAL' && overview[toggle.id].revenue === overview.TOTAL.revenue ? null : (
                    <CardToggle
                        label={toggle.label}
                        compareType={filters.compareTo}
                        metricType={'monetization'}
                        handleClick={changeRevenueToggle}
                        percentChange={{
                            value: formatNumber(overview[toggle.id].revenueChangeRate, 'percent'),
                            direction: getChangeRateDirection(overview[toggle.id].revenueChangeRate)
                        }}
                        selected={revenueToggle===toggle.label}
                        value={formatNumber(overview[toggle.id].revenue, 'dollar')}
                    />
                )
                
            )}
        </CardToggles>
    );

    const formattedData = formatDataForRevenueReport();

    const hasSingleData = () => {
        return formattedData && formattedData[0] && Object.keys(formattedData[0].data).length === 1 ? true : false
    }

	return (
		<CardWrapper klass={`revenuereportsection ${props.classes.revenuereportsection}`} loading={false}>
            { isLoading() && <LoadingState />}
            { isNoData() && <NoDataState title="Total Revenue"/>}
            { isShowData() &&
    			<div className={'data'}>
    				{ cardToggles }
                    { status === 'fulfilled' &&  currentTotalDetail.length > 0 && overview[dataType].revenue > 0 &&
                        <>
                            <RevenueReportChart compareTo={currentCompareTo} enablePoints={hasSingleData()} status={status} period={selected} data={formattedData} />
                            <LinkControls
                                selected={selected}
                                handleSelect={changeSelected}
                                options={
                                    [
                                        {text: 'Daily', value: 'daily', disabled: enabledRollups.indexOf('daily') < 0},
                                        {text: 'Weekly', value: 'weekly', disabled: enabledRollups.indexOf('weekly') < 0},
                                        {text: 'Monthly', value: 'monthly', disabled: enabledRollups.indexOf('monthly') < 0},
                                        {text: 'Quarterly', value: 'quarterly', disabled: enabledRollups.indexOf('quarterly') < 0}
                                    ]
                                }
                            />
                        </>
                    }
    			</div>
            }
		</CardWrapper>
	);
});




/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default RevenueReportSection;
